module.exports = __webpack_public_path__ + "img/1.142fd30.png";